import { combineReducers } from "redux";
import type { Reducer } from "redux";
import { persistReducer } from "redux-persist";

import type { ReduxState } from "@dashboard/types/reduxState";

import { brandingReducer } from "./brandingReducer";
import {
  dashboardAppPersistConfig,
  dashboardAppReducer,
} from "./dashboardReducer";
// App reducers
import { dishReducer } from "./dishReducer";
import { errorReducer } from "./errorReducer";
import { locationReducer } from "./locationReducer";
import { menuReducer } from "./menuReducer";
import { productReducer } from "./productReducer";
import { resolvedEdiblesReducer } from "./resolvedEdiblesReducer";
import {
  restaurantReducer,
  restaurantReducerPersistConfig,
} from "./restaurantReducer";
import { supplierReducer } from "./supplierReducer";
import { termsAcceptanceReducer } from "./termsAcceptanceReducer";

export const rootReducer = ({ usePersist }: { usePersist: boolean }) =>
  combineReducers({
    dish: dishReducer,
    product: productReducer,
    resolvedEdibles: resolvedEdiblesReducer,
    menu: menuReducer,
    restaurant: (usePersist
      ? persistReducer(restaurantReducerPersistConfig, restaurantReducer)
      : restaurantReducer) as Reducer<ReduxState["restaurant"]>,
    location: locationReducer,
    termsAcceptance: termsAcceptanceReducer,
    branding: brandingReducer,
    supplier: supplierReducer,
    error: errorReducer,
    dashboardApp: (usePersist
      ? persistReducer(dashboardAppPersistConfig, dashboardAppReducer)
      : dashboardAppReducer) as Reducer<ReduxState["dashboardApp"]>,
  }) as Reducer<ReduxState>;
